import type { TierIIChemicalCandidate } from '../types/reporting.ts';
const percent = new Intl.NumberFormat('en-US', { style: 'percent', maximumFractionDigits: 6 });
export function concentrationExclusionLabel(product: TierIIChemicalCandidate['products'][number]) {
  const exclusion = product.concentrationExclusion;
  return exclusion
    ? 'Below concentration cutoff: ' +
        percent.format(exclusion.concentration) +
        ' ≤ ' +
        percent.format(exclusion.cutoff)
    : 'Concentration excluded — review composition';
}
